module.exports = __webpack_public_path__ + "img/reorder_suggestions.f453f6e2.svg";